import { atomWithStorage } from 'jotai/utils';

export const featureFlags = atomWithStorage<{ [key: string]: boolean }>('tymely-featureFlags', {});
